// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.star-rating[data-v-6ac6593f] {\n  display: inline-block;\n}\n.star[data-v-6ac6593f] {\n  display: inline-block;\n  font-size: 36px;\n  cursor: pointer;\n  margin: 2px;\n  color: rgb(222, 222, 222);\n}\n.filled[data-v-6ac6593f] {\n  color: gold;\n}\n", ""]);
// Exports
module.exports = exports;
